import React, { useEffect, useMemo } from 'react'
import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Text
} from '@chakra-ui/react'
import { LABEL } from '../../../../constants'

const DocumentDateField = ({
  allowedMinDate,
  documentData,
  field,
  meta,
  form
}) => {
  const normalizeDate = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const issueDate = useMemo(
    () => documentData?.issueDate ? normalizeDate(new Date(documentData.issueDate)) : null,
    [documentData]
  )

  const allowedMin = useMemo(
    () => allowedMinDate ? normalizeDate(allowedMinDate) : null,
    [allowedMinDate]
  )

  const minDate = useMemo(() => {
    if (!allowedMin) return null

    return allowedMin
  }, [allowedMin]) 

  const toInputDate = (date) => {
    if (!date) return ''
    const yyyy = date.getFullYear()
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  const parseInputDate = (value) => {
    if (!value) return null
    const [yyyy, mm, dd] = value.split('-').map(Number)
    return new Date(yyyy, mm - 1, dd)
  }

  const clampToMin = (date) => {
    if (!date || !minDate) return date
    return normalizeDate(date) < minDate ? minDate : date
  }

  let finalDate = null
  if (field.value) {
    finalDate = normalizeDate(new Date(field.value))
  } else if (issueDate && (!minDate || issueDate >= minDate)) {
    finalDate = issueDate
  } else if (minDate) {
    finalDate = minDate
  }

  useEffect(() => {
    if (!field.value && finalDate) {
      form.setFieldValue(field.name, finalDate.getTime())
    }
  }, [finalDate, field.value, form, field.name])

  return (
    <FormControl isInvalid={meta.touched && !!meta.error}>
      <FormLabel textColor="gray.500" mb="0" fontSize="sm">
        {LABEL.DOCUMENT_DATE.label}
      </FormLabel>
      <Input
        bg="white"
        borderRadius="lg"
        size="sm"
        type="date"
        border="1px"
        borderColor="black"
        {...(minDate && { min: toInputDate(minDate) })}
        value={toInputDate(finalDate)}
        onChange={(e) => {
          const value = e.target.value
          const selected = parseInputDate(value)
          const clamped = clampToMin(selected)
          form.setFieldValue(field.name, clamped ? clamped.getTime() : null)
        }}
        onBlur={() => {
          form.setFieldTouched(field.name, true)
          if (field.value) {
            const selected = new Date(field.value)
            const clamped = clampToMin(selected)
            form.setFieldValue(field.name, clamped.getTime())
          }
        }}
      />
      {meta.error && <FormErrorMessage>{meta.error}</FormErrorMessage>}
      {minDate && (
        <Text fontSize="xs" color="gray.500">
          {LABEL.MINIMUM_DATE.label}{' '}
          {toInputDate(minDate)}
        </Text>
      )}
    </FormControl>
  )
}

export default DocumentDateField